module.exports = __webpack_public_path__ + "static/media/93.9802b64a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/93.jpg
// module id = 1025
// module chunks = 0